import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { API_HOST } from '@/config';
import { useToast } from '@/hooks/useToast';
import {
  extractServerErrorMsg,
  SupportTimesSettings,
  SUPPORT_TIMES_SETTINGS_QUERY_KEY,
} from '@/queries';
import client, { ApiRoutes } from '@/store/client';

const getSupportTimesSettings = (featureId?: string) => {
  return () => {
    return client.get<SupportTimesSettings>(
      `${API_HOST}/${ApiRoutes.LiveChat}/${featureId}/settings/supporttimes`,
    );
  };
};

export const useGetSupportTimesSettings = (featureId?: string) => {
  const { toast } = useToast();

  const { data, isLoading } = useQuery(
    [SUPPORT_TIMES_SETTINGS_QUERY_KEY, featureId],
    getSupportTimesSettings(featureId),
    {
      enabled: featureId ? true : false,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      onError: (errorResponse: AxiosError) => {
        toast(
          extractServerErrorMsg(errorResponse, 'Failed to get support times settings.'),
          {
            variant: 'error',
          },
        );
      },
    },
  );

  const supportTimesSettings = data?.data;
  return { supportTimesSettings, isLoading };
};
